// Keep catalogue identity through the whole album → reviews → review → album loop.
// Other UI queries and comment anchors are not part of a shareable album identity.
export function reviewRoutePaths(pathname, search = '') {
  const albumPath = pathname.split('/user-reviews')[0].split('/comment/')[0].replace(/\/$/, '');
  const sourceId = new URLSearchParams(search).get('source_id');
  const query = sourceId ? `?${new URLSearchParams({ source_id: sourceId })}` : '';
  return {
    album: albumPath + query,
    list: `${albumPath}/user-reviews${query}`,
    detail: (id) => `${albumPath}/user-reviews/${encodeURIComponent(id)}${query}`,
  };
}
export function appendReviewId(listPath, id) {
  const [pathname, search = ''] = listPath.split('?');
  return `${pathname}/${encodeURIComponent(id)}${search ? `?${search}` : ''}`;
}
export const isMemberReviewList = (path) =>
  /^\/reviews\/[^/]+(?:\/[^/]+)?\/user-reviews\/?$/.test(path);

export const isMemberReviewSurface = (path) =>
  /^\/reviews\/[^/]+(?:\/[^/]+)?\/user-reviews(?:\/[^/]+(?:\/comment\/[^/]+)?)?\/?$/.test(path);
